import { Box, Flex, Paper, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  message: string;
};

export function SteeringFollowUpCard({ message }: Props) {
  return (
    <Paper
      w={374}
      radius={24}
      py="sm"
      px="md"
      style={{
        background: 'rgba(0, 0, 0, 0.05)',
        backdropFilter: 'blur(50px)',
        border: '1px solid rgba(253, 253, 253, 0.15)',
      }}
    >
      <Flex direction="column" align="center" gap="xs">
        <Text size="md" fw={FONT_WEIGHTS.bold} c="white" ta="center">
          Next step
        </Text>
        <Box
          w="100%"
          p="md"
          style={{
            background: 'rgba(0, 0, 0, 0.20)',
            borderRadius: 'var(--mantine-radius-lg)',
          }}
        >
          <Text size="sm" fw={FONT_WEIGHTS.medium} c="white" ta="center">
            {message}
          </Text>
        </Box>
      </Flex>
    </Paper>
  );
}
